.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);
}

.container {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}
